<div class="min-h-screen flex items-center justify-center bg-white">
  <span class="text-2xl font-bold tracking-tight animate-pulse" style="color: #1C3762;">Clarity</span>
</div>
